export default __webpack_public_path__ + "static/media/img-button-Learn-More.e974dcbb.svg";